// Leicestershire school holidays — fetched from the backend (which keeps the
// dates fresh year-on-year, estimating unpublished years). Static fallback below.
import api from './api';

const FALLBACK = [
  { from: '2026-07-08', to: '2026-08-23', label: 'Summer holidays' },
  { from: '2026-10-17', to: '2026-10-25', label: 'October half-term' },
  { from: '2026-12-19', to: '2027-01-03', label: 'Christmas holidays' },
  { from: '2027-02-13', to: '2027-02-21', label: 'February half-term' },
  { from: '2027-03-20', to: '2027-04-04', label: 'Easter holidays' },
  { from: '2027-05-29', to: '2027-06-06', label: 'May half-term' },
  { from: '2027-07-07', to: '2027-08-22', label: 'Summer holidays' },
];

let _cache = null;
export async function getSchoolHolidays() {
  if (_cache) return _cache;
  try {
    const r = await api.get('/school-holidays');
    if (Array.isArray(r.data?.items) && r.data.items.length) {
      _cache = r.data.items;
      return _cache;
    }
  } catch { /* fall back to the static list */ }
  _cache = FALLBACK;
  return _cache;
}

export const localIso = (d) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

// The holiday we're currently inside, or null in term time.
export function findCurrentHoliday(ranges, now = new Date()) {
  const today = localIso(now);
  return (ranges || []).find((r) => r.from <= today && today <= r.to) || null;
}

// The current holiday if inside one, otherwise the next upcoming one.
export function findNextHoliday(ranges, now = new Date()) {
  const today = localIso(now);
  return (ranges || []).find((r) => r.to >= today) || null;
}
